export default __webpack_public_path__ + "static/media/UK_flag.086867f6.jpg";